import {library} from '@fortawesome/fontawesome-svg-core';
import {faIdeal} from '@fortawesome/free-brands-svg-icons';

library.add(
  faIdeal,
);
